module.exports = __webpack_public_path__ + "img/bar.8a536f99.svg";